/** Ranks ที่ห้ามเข้า OT Report (Costing) เด็ดขาด — ตามที่ระบุจาก master ระดับ */
const OT_COSTING_BLOCKED_RANKS = [
  'Trainee',
  'Staff',
  'Senior I',
  'Senior II',
  'Senior III',
  'Supervisor',
  'Head',
  'Management Trainee',
  'Assistant Manager',
  'พนักงานฝึกหัด',
  'พนักงานทั่วไป',
  'พนักงานอาวุโสระดับ 1',
  'พนักงานอาวุโสระดับ 2',
  'พนักงานอาวุโสระดับ 3',
  'หัวหน้างาน',
  'ผู้จัดการฝึกหัด',
  'ผู้ช่วยผู้จัดการ',
];

const BLOCKED_NORM = new Set(OT_COSTING_BLOCKED_RANKS.map((r) => r.toLowerCase()));

/** ตัด "Senior I (…)" → "Senior I", trim, lower */
function normalizeRank(rank) {
  return String(rank)
    .trim()
    .split('(')[0]
    .trim()
    .toLowerCase();
}

export function isOtCostingBlockedRank(rank) {
  if (rank == null || String(rank).trim() === '') return false;
  return BLOCKED_NORM.has(normalizeRank(rank));
}

/** เห็นเมนูได้ทุกคน ยกเว้น rank ในรายการบล็อก */
export function canAccessOtCosting(emp) {
  if (!emp) return false;
  return !isOtCostingBlockedRank(emp.rank);
}
